import { render, staticRenderFns } from "./ConfigUpdatedDialog.vue?vue&type=template&id=74940512"
import script from "./ConfigUpdatedDialog.vue?vue&type=script&lang=ts"
export * from "./ConfigUpdatedDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports